export const WAREHOUSE_CARDS_ROWS_PER_PAGE = 10;
